export function goToFirstError(i) {
  if (!i.valid) {
    this.$vuetify.goTo(i, { offset: 50 });
  }
  return i.valid;
}

export default {
  methods: {
    goToFirstError,
  },
};
